import { useMutation, useQueryClient } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import {
  submitTaskAction,
  rejectLeaveRequest
} from 'RestAPIs/planner-messages';
import { MessageActionType } from '../types';
import { LEAVE_REQUEST_TASK_KEYS } from '../constants';

const useSubmitTaskAction = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (variables: {
      taskId: string;
      actionType: MessageActionType;
      note?: string;
      taskDefinitionKey?: string;
      leaveRequestId?: string;
    }) => {
      const isLeaveReject =
        variables.actionType === MessageActionType.REJECT &&
        variables.taskDefinitionKey &&
        (LEAVE_REQUEST_TASK_KEYS as readonly string[]).includes(
          variables.taskDefinitionKey
        ) &&
        variables.leaveRequestId;

      if (isLeaveReject) {
        return rejectLeaveRequest({
          leaveRequestId: variables.leaveRequestId!,
          note: variables.note || ''
        });
      }

      return submitTaskAction(variables);
    },
    {
      onSuccess: () => {
        showSuccessSnackbar();
        queryClient.invalidateQueries('plannerTasks');
        queryClient.invalidateQueries('plannerTaskTabCounts');
      },
      onError: () => showErrorSnackbar()
    }
  );

  return { mutateAsync, isLoading };
};

export default useSubmitTaskAction;
